<template>
  <main id="investors">
    <forminvhero/>
    <location />
    <cta />
    <speakers />
    <presenters />
    <sponsors />
  </main>
</template>

<style lang="scss" scoped>
  @import '../styles/pages/home.scss';
</style>

<script>
// @ is an alias to /src
import forminvhero from '@/components/forminvhero.vue';
import location from '@/components/location.vue';
import cta from '@/components/cta.vue';
import sponsors from '@/components/sponsors.vue';
import presenters from '@/components/presenters.vue';
import speakers from '@/components/speakers.vue';

export default {
  name: 'Investors',
  data() {
    return {
    };
  },
  components: {
    forminvhero,
    location,
    cta,
    sponsors,
    presenters,
    speakers
  },
  methods: {
  },
  mounted() {
  },
};
</script>
